import {Assert, E} from "js-vextensions";
import {InAndroid} from "../Bridge/Bridge_Native";
import {screenOn} from "../Bridge/Bridge_Native/PhoneSensors.js";
import {PluginGeneral} from "../Capacitor/GeneralPlugin.js";

export function SendUserProcessesBridgeMessage_RobustGraphlinkSet(processMessage: any) {
	/*//const collectionPath = DBPath({}, `userExtras/${MeID()}/processMessages`);
	const collectionPath = DBPath({}, `userProcessMessages`);
	//const documentID = processMessage.sendTime.toString();
	const documentID = GenerateUUID();
	return RobustFirebaseSet(collectionPath, documentID, processMessage);*/
	throw new Error("Not yet implemented.");

	return {};
}

export async function RobustFetch(url: string, options: RequestInit): Promise<Response> {
	if (InAndroid(0) && !screenOn) {
		const supportedKeys = ["method", "cache", "headers", "body"];
		Assert(options.VKeys().All(key=>supportedKeys.includes(key)));
		if (options.cache) Assert(options.cache == "no-cache", `Only supports "no-cache" for cache property.`);

		const result = await PluginGeneral.RobustFetch(E({url}, options));
		const fetchResponseStr = result.fetchResponseStr as string;
		//var fetchResponseStr_blob = new Blob([ToJSON(fetchResponseStr)], {type: "application/json"});
		var fetchResponseStr_blob = new Blob([fetchResponseStr], {type: "text/plain"});
		const reconstructedResponse = new Response(fetchResponseStr_blob, {status: 200, statusText: "SuperSmashingGreat!"});
		//return new Promise(resolve=>resolve(reconstructedResponse));
		return reconstructedResponse;
	}
	return fetch(url, options);
}